// import { Link } from "react-router-dom";
// import CommonTable from "../../components/CommonTable";

// const MyTeam = () => {
//     const teamMembers = [
//         {
//             "Team Member": "Emma Carter",
//             "Email Address": "emmacarter1234@gmail.com",
//             "Access Level": "Full Access",
//         },
//         {
//             "Team Member": "Liam Patel",
//             "Email Address": "liampatel65416@gmail.com",
//             "Access Level": "Limited Access",
//         },
//         {
//             "Team Member": "Sophia Rodriguez",
//             "Email Address": "sophiar1234@gmail.com",
//             "Access Level": "Full Access",
//         },
//         {
//             "Team Member": "Noah Bennett",
//             "Email Address": "noahbennett5534@gmail.com",
//             "Access Level": "Full Access",
//         },
//         {
//             "Team Member": "Emma Carter",
//             "Email Address": "emmacarter1234@gmail.com",
//             "Access Level": "Full Access",
//         },
//         {
//             "Team Member": "Liam Patel",
//             "Email Address": "liampatel65416@gmail.com",
//             "Access Level": "Limited Access",
//         },
//         {
//             "Team Member": "Sophia Rodriguez",
//             "Email Address": "sophiar1234@gmail.com",
//             "Access Level": "Full Access",
//         },
//         {
//             "Team Member": "Noah Bennett",
//             "Email Address": "noahbennett5534@gmail.com",
//             "Access Level": "Full Access",
//         },
//         {
//             "Team Member": "Emma Carter",
//             "Email Address": "emmacarter1234@gmail.com",
//             "Access Level": "Full Access",
//         },
//         {
//             "Team Member": "Liam Patel",
//             "Email Address": "liampatel65416@gmail.com",
//             "Access Level": "Limited Access",
//         },
//         {
//             "Team Member": "Sophia Rodriguez",
//             "Email Address": "sophiar1234@gmail.com",
//             "Access Level": "Full Access",
//         },
//         {
//             "Team Member": "Noah Bennett",
//             "Email Address": "noahbennett5534@gmail.com",
//             "Access Level": "Full Access",
//         },
//     ];

//     const columns = ["Team Member", "Email Address", "Access Level"];

//     const actions = (row) => (
//         <>
//             <Link to="#" className="btns-table edit-btn">
//                 <i className="icon-icon-8"></i> Edit
//             </Link>
//             <button className="btns-table remove-btn">
//                 <i className="icon-icon-30"></i> Remove
//             </button>
//         </>
//     );

//     const pagination = {
//         info: `Showing 1 - ${teamMembers.length} of ${teamMembers.length}`,
//         hasPrev: false,
//         hasNext: false,
//         onPrev: () => console.log("Prev clicked"),
//         onNext: () => console.log("Next clicked"),
//     };

//     return (
//         <div className="admin-page my-team-page">
//             <div className="admin-page-title d-flex align-items-center justify-content-between">
//                 <h1 className="page-section-title">My Team</h1>
//                 <Link to="/my-team/add-team" className="btns">
//                     <i className="icon-icon-5"></i> Add Team Member
//                 </Link>
//             </div>

//             <CommonTable
//                 columns={columns}
//                 data={teamMembers}
//                 actions={actions}
//                 pagination={pagination}
//             />
//         </div>
//     );
// };

// export default MyTeam;


import { Link, useNavigate } from "react-router-dom";
import CommonTable from "../../components/CommonTable";
import { useEffect, useState } from "react";
import axios from "axios";

const MyTeam = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState(null);
  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}auth/list_users`,
        {
          headers: {
            "api-key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.status === "success") {
        const { users, pagination } = res.data.data;

        const formatted = users.map((u) => ({
          id: u.id,
          "Team Member": u.name,
          "Email Address": u.email,
          "Access Level": u.access_level === 1 ? "Full Access" : "Limited Access",
        }));

        setTeamMembers(formatted);
        setPagination(pagination);
      }
    } catch (error) {
      console.error("Error fetching team members:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleRemove = async (id) => {
    if (!window.confirm("Are you sure you want to remove this user?")) return;
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}auth/delete_user`,
        { id },
        {
          headers: {
            "api-key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.status === "success") {
        setTeamMembers((prev) => prev.filter((m) => m.id !== id));
      } else {
        alert("Failed to remove user");
      }
    } catch (err) {
      console.error("Error removing user:", err);
      alert("Failed to remove user");
    }
  };

  const columns = ["Team Member", "Email Address", "Access Level"];

  const actions = (row) => (
    <>
      <Link to={`/my-team/edit/${row.id}`} className="btns-table edit-btn">
        <i className="icon-icon-8"></i> Edit
      </Link>
      <button
        className="btns-table remove-btn"
        onClick={() => handleRemove(row.id)}
      >
        <i className="icon-icon-30"></i> Remove
      </button>
    </>
  );

  const paginationInfo = pagination
    ? {
        info: `Showing ${(pagination.page - 1) * pagination.pageSize + 1} - ${
          (pagination.page - 1) * pagination.pageSize + teamMembers.length
        } of ${pagination.total}`,
        hasPrev: pagination.page > 1,
        hasNext: pagination.page < pagination.totalPages,
        onPrev: () => console.log("Prev clicked"),
        onNext: () => console.log("Next clicked"),
      }
    : null;

  return (
    <div className="admin-page my-team-page">
      <div className="admin-page-title d-flex align-items-center justify-content-between">
        <h1 className="page-section-title">My Team</h1>
        <Link to="/my-team/add" className="btns">
          <i className="icon-icon-5"></i> Add Team Member
        </Link>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <CommonTable
          columns={columns}
          data={teamMembers}
          actions={actions}
          pagination={paginationInfo}
        />
      )}
    </div>
  );
};

export default MyTeam;

